export enum PopUpType {
  ALERT = 'alert',
  CONFIRM = 'confirm'
}
